export default {
  CONTENT: 'content',
  NOTIFICATION: 'notification',
  ASSIGNMENT: 'assignment_notifications',
  DUE_DATE: 'due_date_notifications',
  PAST_DUE: 'past_due_notifications',
};
